export const useZIndex = (level, bit = 0) => {
    const map = {
        1: 1,
        2: 9,
        3: 99,
        4: 599,
        5: 999,
        6: 1499,
        7: 2001,
        8: 9999,
        9: 14999,
        10: 20000,
        11: 200000
    }
    return `${map[level] + bit}`
}

export const __NORMAL_ZINDEX__ = 'normal-z-index'

/**
 * @description
 * 弹窗弹起时，临时覆盖其他组件,设置z-index: 1
 * 弹窗关闭时，恢复其他组件z-index 为原始设定
 * @param {Boolean} open 是否打开弹窗
 **/

export const toggleZIndexToNormal = (open = true) => {
    const backToTop = $(document).find('.back-to-top');
    const fixedComponent = $(document).find('.mdws-fixedComponents-fixed .mdws-fixedComponents-container');
    const productPayCardShop = $(document).find('.product-payCard-shop');
  
    const dom = [backToTop, fixedComponent, productPayCardShop ]
    if (open) {
        dom.forEach(e => { e.addClass(__NORMAL_ZINDEX__) })
    } else {
        dom.forEach(e => { e.removeClass(__NORMAL_ZINDEX__) })
    }
}